import { apiRequest } from "./client";
import type { KnowledgeNodeDetail, KnowledgeNodeRecord } from "./memory";

interface ApiResponse<T> {
  status: "success";
  data: T;
}

export interface WorkSkillStep {
  step_id: string;
  text: string;
  directions?: string[];
  tips?: string[];
  tools?: string[];
  supplies?: string[];
}

export interface WorkSkillSection {
  title: string;
  steps: WorkSkillStep[];
}

export interface StepReplacement {
  op: "replace";
  step_id: string;
  text: string;
}

export async function listWorkSkills(): Promise<KnowledgeNodeRecord[]> {
  const response = await apiRequest<ApiResponse<KnowledgeNodeRecord[]>>(
    "/api/v1/memory/nodes/?node_type=process&status=active&include_shared=true",
  );
  return response.data;
}

export async function createAdaptedWorkSkill(input: {
  title: string;
  libraryRef: string;
  activityId: string;
  overlay: StepReplacement[];
}): Promise<KnowledgeNodeDetail> {
  const response = await apiRequest<ApiResponse<KnowledgeNodeDetail>>(
    "/api/v1/memory/nodes/",
    {
      method: "POST",
      body: {
        node_type: "process",
        metadata: {
          title: input.title,
          adapts: input.libraryRef,
          overlay: input.overlay,
        },
        edges: [
          { relationship_type: "for_activity", target_id: input.activityId },
        ],
      },
    },
  );
  return response.data;
}
